'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 生成与spm对应的checksum
var makeSpmChkSum = function makeSpmChkSum(s) {
  s = (s || '').split('#')[0].split('?')[0];
  var len = s.length;
  var hash = function hash(str) {
    var i = void 0;
    var l = str.length;
    var key = 0;
    for (i = 0; i < l; i++) {
      /* eslint-disable */
      key = key * 31 + str.charCodeAt(i);
    }
    return key;
  };
  return len ? hash(len + '#' + s.charCodeAt(len - 1)) : -1;
};

var goldlog = {

  /**
   * click event gold
   * @inheritDoc http://aplus.alibaba-inc.com/track/info.htm?spm=a1z3g./2396.0.0.6b44f21e8mXs9p&type=2504
   * @param logKey 即完整的令箭编码
   * @param goKeyObject
   * @param gmKey 关键业务类型
   * @param chkSum
   */
  record: function record(logKey, gmKey, goKeyObject, chkSum) {
    if (window.goldlog && window.goldlog.record) {
      goKeyObject = Object.assign({ platform: 'web' }, goKeyObject);
      window.goldlog.record(logKey, gmKey, _queryString2.default.stringify(goKeyObject), chkSum);
    }
  },


  /**
   * click event
   * @param logKey
   * @param chkSum
   * @param goKeyObject
   */
  click: function click(logKey, chkSum, goKeyObject) {
    goldlog.record(logKey, 'CLK', goKeyObject, chkSum);
  },
  show: function show(logKey, chkSum, goKeyObject) {
    goldlog.record(logKey, 'EXP', goKeyObject, chkSum);
  },
  setPageSpm: function setPageSpm(spmB) {
    var goldLogQueue = window.goldlog_queue || (window.goldlog_queue = []);
    var spmA = 'a2o42';
    if (window.goldlog && window.goldlog.spm_ab && window.goldlog.spm_ab.length) {
      spmA = window.goldlog.spm_ab[0];
    }
    // setPageSPM
    goldLogQueue.push({
      action: 'goldlog.setPageSPM',
      arguments: ['', spmB]
    });
    // sendPV
    // checksum could be generated here : http://on.alibaba.net/
    goldLogQueue.push({
      action: 'goldlog.sendPV',
      arguments: [{
        pageid: '',
        checksum: makeSpmChkSum(spmA + '.' + spmB)
      }]
    });

    //push a new page view event to dataLayer:
    var dataLayer = window.dataLayer || [];
    dataLayer.push({ event: 'page_view' });
  }
};

exports.default = goldlog;